import React, { useContext } from "react";
import styled from "styled-components";
import DATA_MODEL_TABLE from "../../../utils/constants/dataModelTable";
import ACTION_LOGS_DATA_MODEL from "../../../utils/constants/actionLogsDataModel";
import { entryType, equipmentStatus, formStates, formTypes } from "../../../constants";
import { LogBookSelectContext } from "./logBooksSelectAll/context";
import ClusterAgGridTableAddFlowFirstStep from "../../../components/shared/ClusterAgGridTableAddFlowFirstStep";
import { uniq } from "underscore";
import { useEffect } from "react";
import { useState } from "react";
import { useFormikContext } from "formik";
import { useSelector } from "react-redux";
import { runLogsClearSuggestion } from "../run-logs/run-logs-form/run-logs-clear-suggestion";
import { runLogsSelectSuggestion } from "../run-logs/run-logs-form/run-logs-select-suggestion";
import { CoverSheetMainPageContext } from "../../cover-sheet/cover-sheet-main-page-context/context";
import { capitalize, find } from "lodash";
import { replaceEmptyWithHyphen } from "../../../utils/helpers/text";
import { OwcChip, OwcTypography } from "@one/react";
import { ClusterActions } from "../../../components/shared/ClusterActions";
import { EN_DASH } from "@digitallab/grid-common-frontend-components";
import { defaultHeadCellProps } from "../log-sheet/log-sheet-form/ActionDataInputsBoxClusterImpact";

const LogBookTableStyled = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  & .row {
    background-color: #fafafa;
  }
`;

export const subClusterMapping = (obj, selected = null) => {
  let data = [obj];
  let tempData = [...data];
  let tempRowList = [];
  let parentArray = [];
  tempData[0]?.forEach((item) => {
    let subParentArray = uniq([...parentArray, item?.inventoryId]);
    const subClusterParent = uniq([...subParentArray]);
    if (selected) {
      if (find(selected, { inventoryId: item?.inventoryId })) {
        tempRowList.push({ ...item, clusterParent: subClusterParent });
      }
    } else {
      tempRowList.push({ ...item, clusterParent: subClusterParent });
    }
    if (item?.subEquipment) {
      item.subEquipment.forEach((element) => {
        const childClusterParent = uniq([...subParentArray, element?.inventoryId]);

        if (selected) {
          if (find(selected, { inventoryId: element?.inventoryId })) {
            tempRowList.push({ ...element, clusterParent: childClusterParent });
          }
        } else {
          tempRowList.push({ ...element, clusterParent: childClusterParent });
        }
      });
    }
  });

  return tempRowList;
};

const LogBookClusterTable = ({ dataTestId, equipmentDetail }) => {
  const { onSetSelection, selected } = useContext(LogBookSelectContext);
  const [clusterSubEquipmentDetails, setClusterSubEquipmentDetails] = useState([]);
  const gxpReadys = useSelector((store) => store.runLogsForm.gxpReadys);

  const { formState, logType } = useContext(CoverSheetMainPageContext);
  const formik = useFormikContext();
  const user = useSelector((store) => store.user);

  useEffect(() => {
    if (logType === formTypes.RUN_LOG) {
      if (formState !== formStates.EDITABLE_FORM) {
        runLogsClearSuggestion({ formik, user, equipmentDetail });
      } else {
        runLogsSelectSuggestion(equipmentDetail, { formik, user });
      }
    }
    // eslint-disable-next-line
  }, [formState]);

  useEffect(() => {
    const clusterDetails = () => {
      const coverSheetDetail = subClusterMapping(equipmentDetail?.subEquipment);

      setClusterSubEquipmentDetails(() => coverSheetDetail);
    };

    if (equipmentDetail?.subEquipment) {
      clusterDetails();
    }
  }, [equipmentDetail]);
  const EquipmentMetaDisplay = {
    fields: {
      clusterIdentifier: {
        headProps: { style: { width: 100 } },
        cellProps: { style: { width: 100 } },
        text: "",
        pinned: "left",
        lockPinned: true,
        sortable: false,
        component: ({ item, triggerClusterSetCollapse, client, clusterEquipmentInfoAction }) => {
          switch (item.entryType) {
            case entryType?.cluster:
              return (
                <ClusterActions
                  client={client}
                  item={item}
                  triggerClusterSetCollapse={triggerClusterSetCollapse}
                  clusterEquipmentInfoAction={clusterEquipmentInfoAction}
                  viewExpander={true}
                />
              );
            default:
              return "";
          }
        }
      },
      equipmentModel: {
        text: DATA_MODEL_TABLE.equipmentModel.value,
        sortable: false,
        pinned: "left",
        lockPinned: true,
        headProps: {
          style: {
            display: "flex",
            alignItems: "center"
          }
        },
        cellProps: {
          style: {
            display: "flex",
            alignItems: "center"
          }
        }
      },
      equipmentId: {
        text: DATA_MODEL_TABLE.equipmentId.value,
        sortable: false,
        ...defaultHeadCellProps
      },
      serialNumber: {
        text: DATA_MODEL_TABLE.serialNumber.value,
        sortable: false,
        ...defaultHeadCellProps
      },
      equipmentNickName: {
        text: DATA_MODEL_TABLE.equipmentNickName.value,
        sortable: false,
        ...defaultHeadCellProps
      },
      status: {
        text: DATA_MODEL_TABLE.status.value,
        sortable: false,
        headProps: {
          style: {
            display: "flex",
            alignItems: "center"
          }
        },
        cellRenderer: (params) => {
          return (
            <OwcChip outlined data-testid="run-data-chip-box-col-value-for-system-status">
              <OwcTypography
                variant="badge"
                style={{
                  color:
                    params?.data?.status === equipmentStatus?.pending?.key
                      ? "var(--one-color-interaction-default-warning-1)"
                      : params?.data?.status === equipmentStatus?.active?.key
                      ? "var(--one-color-interaction-default-positive-1)"
                      : "black"
                }}
              >
                {capitalize(params?.data?.status)}
              </OwcTypography>
            </OwcChip>
          );
        }
      },
      qualificationStatus: {
        text: ACTION_LOGS_DATA_MODEL.gxpReady.value,
        sortable: true,
        headProps: {
          style: {
            display: "flex",
            alignItems: "center"
          }
        },
        cellRenderer: (params) => {
          return (
            <OwcChip outlined data-testid="run-data-chip-box-col-value-for-system-status">
              <OwcTypography variant="badge">
                {replaceEmptyWithHyphen(
                  find(gxpReadys, {
                    key: params?.data?.qualificationStatus
                  })?.value ?? params?.data?.qualificationStatus
                )}
              </OwcTypography>
            </OwcChip>
          );
        }
      },
      equipSystemStatus: {
        text: DATA_MODEL_TABLE.systemStatus.value,
        sortable: true,
        headProps: {
          style: {
            display: "flex",
            alignItems: "center",
            textAlign: "center"
          }
        },
        cellRenderer: (params) => {
          return (
            <OwcChip outlined data-testid="run-data-chip-box-col-value-for-system-status">
              <OwcTypography variant="badge">
                {replaceEmptyWithHyphen(
                  params?.data?.equipSystemStatus?.value ??
                    params?.data?.systemStatus?.value ??
                    (typeof params?.data?.equipSystemStatus === "object"
                      ? typeof params?.data?.systemStatus === "object"
                        ? EN_DASH
                        : params?.data?.systemStatus
                      : params?.data?.equipSystemStatus)
                )}
              </OwcTypography>
            </OwcChip>
          );
        }
      },
      softwareVersion: {
        text: DATA_MODEL_TABLE.softwareVersion.value,
        sortable: false,
        ...defaultHeadCellProps
      },
      configurationBaseline: {
        text: DATA_MODEL_TABLE.configurationBaseline.value,
        sortable: false,
        ...defaultHeadCellProps
      },
      configurationDetails: {
        text: DATA_MODEL_TABLE.configurationDetails.value,
        sortable: false,
        ...defaultHeadCellProps
      }
    },
    rowKeyId: "id"
  };
  return (
    <LogBookTableStyled data-testid={dataTestId}>
      <ClusterAgGridTableAddFlowFirstStep
        data={equipmentDetail ? clusterSubEquipmentDetails : []}
        meta={EquipmentMetaDisplay}
        onSetSelection={onSetSelection}
        selected={selected}
        isEditMode={formState === formStates.EDITABLE_FORM}
      />
    </LogBookTableStyled>
  );
};

export const StatusClusterComponent = ({ params }) => {
  return (
    <>
      <OwcChip outlined data-testid="run-data-chip-box-col-value-for-system-status">
        {params?.data?.status === equipmentStatus?.active?.key && (
          <OwcTypography
            variant="badge"
            style={{
              color: "var(--one-color-interaction-default-positive-1)"
            }}
          >
            {capitalize(params?.data?.status)}
          </OwcTypography>
        )}
        {params?.data?.status === equipmentStatus?.pending?.key && (
          <OwcTypography
            variant="badge"
            style={{
              color: "var(--one-color-interaction-default-warning-1)"
            }}
          >
            {capitalize(params?.data?.status)}
          </OwcTypography>
        )}
      </OwcChip>
    </>
  );
};

export default LogBookClusterTable;
